import React from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const Timer = ({ formattedTime, className, showHours = false }) => {
  const renderTime = () => {
    if (showHours) {
      return `${formattedTime.hours}:${formattedTime.minutes}:${formattedTime.seconds}`;
    }
    return `${formattedTime.minutes}:${formattedTime.seconds}`;
  };

  return (
    <Typography variant="h6" className={className}>
      {renderTime()}
    </Typography>
  );
};

Timer.propTypes = {
  className: PropTypes.string,
  showHours: PropTypes.bool,
  formattedTime: PropTypes.shape({
    hours: PropTypes.number.isRequired,
    minutes: PropTypes.number.isRequired,
    seconds: PropTypes.number.isRequired,
  }).isRequired,
};

export default Timer;
